import { rage, useObservable } from '~/rage';
import { GreenScreenParams } from '~/shared';
import { StyledActionButton } from '../components/ActionButton';
import { StyledCameraSettingsContainer } from '../components/CameraSettingsContainer';
import { CameraSettingsItemColor } from '../components/CameraSettingsItemColor';
import { CameraSettingsItemSlider } from '../components/CameraSettingsItemSlider';
import { StyledCameraSettingsSection } from '../components/CameraSettingsSection';
import { StyledPanelContent } from '../components/PanelContent';
import { StyledPanelFooter } from '../components/PanelFooter';
import { StyledPanelHeader } from '../components/PanelHeader';
import { SettingVehicleRotation } from '../components/SettingVehicleRotation';
import { SettingVehicleSteering } from '../components/SettingVehicleSteering';

const CameraSettings: React.FC = () => {
	const params = useObservable(rage.greenScreen.getCameraParams());

	return (
		<StyledCameraSettingsContainer>
			<StyledPanelHeader>Инструменты</StyledPanelHeader>
			<StyledPanelContent>
				<StyledCameraSettingsSection>
					{params.map(
						(
							{
								name,
								min_value: minValue,
								max_value: maxValue,
								default_value: defaultValue,
								type,
							},
							index,
						) => (
							<CameraSettingsItemSlider
								key={`param#${index}`}
								min={minValue}
								max={maxValue}
								defaultValue={defaultValue}
								onChange={(newValue) =>
									rage.greenScreen.updateParamValue(type, newValue)
								}
							>
								{name}
							</CameraSettingsItemSlider>
						),
					)}
					<CameraSettingsItemColor
						onChange={(newValue) =>
							rage.greenScreen.updateParamValue(
								GreenScreenParams.BodyColor,
								newValue,
							)
						}
					>
						Цвет кузова
					</CameraSettingsItemColor>
				</StyledCameraSettingsSection>
				<StyledCameraSettingsSection style={{ justifyContent: 'space-evenly' }}>
					<SettingVehicleRotation
						onChange={(newValue) =>
							rage.greenScreen.updateParamValue(
								GreenScreenParams.HorizontalAngle,
								newValue,
							)
						}
					/>
					<SettingVehicleSteering
						onChange={(newValue) =>
							rage.greenScreen.updateParamValue(
								GreenScreenParams.SteeringAngle,
								newValue,
							)
						}
					/>
					{/* <StyledCameraSettingsSubSection>
						<SettingVehicleSteering
							onChange={(newValue) =>
								rage.greenScreen.updateParamValue(
									GreenScreenParams.SteeringAngle,
									newValue,
								)
							}
						/>
						<SettingWorldTime
							onChange={(newValue) =>
								rage.greenScreen.updateParamValue(
									GreenScreenParams.ClockTime,
									newValue,
								)
							}
						/>
					</StyledCameraSettingsSubSection> */}
				</StyledCameraSettingsSection>
			</StyledPanelContent>
			<StyledPanelFooter>
				<StyledActionButton onClick={() => rage.greenScreen.exit()}>
					Выйти
				</StyledActionButton>
				<StyledActionButton onClick={() => rage.greenScreen.takeScreenshot()}>
					Сделать скриншот
				</StyledActionButton>
			</StyledPanelFooter>
		</StyledCameraSettingsContainer>
	);
};

export { CameraSettings };
